import { Routes } from '@angular/router';
import { TenantGuard } from './services/tenant.guard.service';

export const routes: Routes = [
	{
		path: '',
		pathMatch: 'full',
		loadComponent: () => import('./views/home/home').then((m) => m.Home),
	},
	{
		path: 'no-subdomain',
		loadComponent: () => import('./views/error-pages/no-subdomain/error.subdomain.component').then((m) => m.ErrorSubdomainPageComponent),
	},
	{
		path: 'login',
		loadComponent: () => import('./views/login/login.component').then((m) => m.LoginComponent),
	},
	{
		path: 'signup',
		loadComponent: () => import('./views/signup/signup.component').then((m) => m.SignupComponent),
	},
	{
		path: 'reset-password',
		loadComponent: () => import('./views/reset-password/reset-password.component').then((m) => m.ResetPasswordComponent),
	},

	{
		path: ':tenant',
		canActivate: [TenantGuard],
		children: [
			{
				path: 'login',
				loadComponent: () => import('./views/login/login.component').then((m) => m.LoginComponent),
			},
			{
				path: 'signup',
				loadComponent: () => import('./views/signup/signup.component').then((m) => m.SignupComponent),
			},
			{
				path: 'reset-password',
				loadComponent: () => import('./views/reset-password/reset-password.component').then((m) => m.ResetPasswordComponent),
			},
			{
				path: 'cards',
				loadComponent: () => import('./views/wallet/wallet-router/wallet.router').then((m) => m.WalletRouter),
				children: [
					{
						path: '',
						loadComponent: () => import('./views/wallet/wallet-page/wallet.component').then((m) => m.WalletComponent),
					},
				],
			},

			{
				path: 'add-card',
				loadComponent: () => import('./views/cards/add-cards-router/add.cards.router').then((m) => m.AddCardsRouter),
				children: [
					{
						path: 'qr-scan',
						loadComponent: () => import('./views/cards/scan-qr-code/scan-qr-code.component').then((m) => m.ScanQrCodeComponent),
					},
					{
						path: 'pass-card',
						loadComponent: () => import('./views/cards/pass-card/pass-card.component').then((m) => m.PassCardComponent),
					},
					{
						path: 'confirm-card',
						loadComponent: () => import('./views/cards/confirm-card/confirm-card.component').then((m) => m.ConfirmCardComponent),
					},
					{
						path: 'finish-card',
						loadComponent: () => import('./views/cards/finish-card/finish-card.component').then((m) => m.FinishCardComponent),
					},
					{
						path: '',
						redirectTo: 'qr-scan',
						pathMatch: 'full',
					},
				],
			},
			{
				path: 'machine',
				loadComponent: () => import('./views/machine/machine-router').then((m) => m.MachineRouter),
				children: [
					{
						path: 'use',
						loadComponent: () => import('./views/machine/machine-use/machine-use').then((m) => m.MachineUse),
					},
					{
						path: 'approved',
						loadComponent: () => import('./views/machine/machine-approved/machine-approved').then((m) => m.MachineApproved),
					},
					{
						path: '',
						redirectTo: 'use',
						pathMatch: 'full',
					},
				],
			},
			{
				path: '',
				redirectTo: 'cards',
				pathMatch: 'full',
			},
		],
	},
	{
		path: '**',
		loadComponent: () => import('./views/error-pages/404/error.page.component').then((m) => m.ErrorPageComponent),
	},
];
